var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIonic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0594 0.000215546C58.1754 0.000215546 65.8172 1.89631 72.9859 5.56936L73.9336 6.04358L73.1043 6.69514C71.0902 8.29475 69.4906 10.3682 68.4832 12.7377L68.1871 13.3893L67.5949 13.0932C62.0852 10.4865 56.2203 9.12404 50.1184 9.12404C27.5473 9.12404 9.2418 27.4889 9.2418 50.0006C9.2418 72.5123 27.4879 90.8776 50.0594 90.8776C72.6305 90.8776 90.9359 72.5127 90.9359 50.0006C90.9359 44.61 89.9289 39.3373 87.7961 34.3608L87.5 33.7092L88.1516 33.4131C90.5805 32.5244 92.7133 31.0436 94.4313 29.1475L95.0828 28.3182L95.4977 29.2662C98.5191 35.842 100 42.8326 100 49.8822C100 77.4295 77.5473 99.8823 50 99.8823C22.4527 99.8823 0 77.4295 0 49.8826C0 22.3358 22.4527 -0.117363 50.0594 0.000215546ZM50.0594 27.2518C62.5594 27.2518 72.8082 37.4416 72.8672 50.06C72.8672 62.6784 62.6777 72.8682 50.0594 72.8682C37.4406 72.8682 27.2512 62.6784 27.2512 50.06C27.2512 37.4416 37.5 27.2518 50.0594 27.2518ZM82.7016 8.41311C88.4598 8.41311 93.1281 13.0811 93.1281 18.8397C93.1281 24.5979 88.4602 29.2662 82.7016 29.2662C76.943 29.2662 72.275 24.5983 72.275 18.8397C72.275 13.0811 76.943 8.41311 82.7016 8.41311Z",
    fill: "#3880FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonic);
export default __webpack_public_path__ + "static/media/ionic.bbc948db89468f504483f478a51d25ec.svg";
export { ForwardRef as ReactComponent };